import React, { useState, useRef } from "react";
import "./Academia.css";
import {
   FaMailBulk,
   FaWhatsapp,
   FaClock,
   FaMapMarker,
   FaRegCheckCircle,
   FaRegQuestionCircle,
   FaTimes,
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import ReCAPTCHA from "react-google-recaptcha";

const Contact = () => {
   const [loadRecaptcha, setLoadRecaptcha] = useState(false);
   const [recaptchaToken, setRecaptchaToken] = useState(null);
   const recaptchaRef = useRef();
   const { t } = useTranslation();

   const [formData, setFormData] = useState({
      name: "",
      email: "",
      phone: "", // Mapeado al campo de WhatsApp
      objective: "", // Mapeado al selector de objetivo
      message: "",
      terms: false,
   });

   const [errors, setErrors] = useState({});
   const [isSubmitting, setIsSubmitting] = useState(false);
   const [submitMessage, setSubmitMessage] = useState("");

   const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({
         ...formData,
         [name]: value,
      });
   };

   const validateForm = () => {
      const newErrors = {};
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const phoneRegex = /^[0-9+\- ]+$/;

      if (!formData.name.trim()) newErrors.name = t("name_required");

      if (!formData.email.trim()) {
         newErrors.email = t("email_required");
      } else if (!emailRegex.test(formData.email)) {
         newErrors.email = t("email_invalid");
      }

      if (formData.phone && !phoneRegex.test(formData.phone)) {
         newErrors.phone = t("phone_invalid");
      }

      if (
         !formData.objective ||
         formData.objective === "Selecciona tu objetivo"
      ) {
         newErrors.objective =
            t("objective_required") || "Selecciona un objetivo válido";
      }

      if (!formData.message.trim()) newErrors.message = t("message_required");

      if (!formData.terms) newErrors.terms = t("terms_required");

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
   };

   const handleSubmit = async (e) => {
      e.preventDefault();

      if (!loadRecaptcha) {
         setLoadRecaptcha(true);
         setSubmitMessage(t("captcha_required"));
         return;
      }

      if (!recaptchaToken) {
         setSubmitMessage(t("captcha_required"));
         return;
      }

      if (validateForm()) {
         setIsSubmitting(true);

         try {
            const response = await fetch(
               "https://formmail.vercel.app/api/send-email",
               {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ ...formData, recaptchaToken }),
               },
            );

            const data = await response.json();
            if (data.success) {
               setSubmitMessage(t("succ_message"));
               setFormData({
                  name: "",
                  email: "",
                  phone: "",
                  objective: "",
                  message: "",
               });
               if (recaptchaRef.current) recaptchaRef.current.reset();
               setRecaptchaToken(null);
            } else {
               setSubmitMessage(t("error_message"));
            }
         } catch (error) {
            setSubmitMessage(t("server_error"));
         } finally {
            setIsSubmitting(false);
         }
      }
   };

   const closeMessage = () => {
      setSubmitMessage("");
   };

   return (
      <section className="contact-section">
         <div className="contact-header">
            <h2 className="contact-title">
               ¿DUDAS? <span>ESCRÍBEME</span>
            </h2>
            <p className="contact-subtitle">
               ¿Tienes dudas sobre qué pack elegir o cómo empezar en el mundo
               FPV? Escríbeme <br />y te ayudo a decidir la mejor ruta para tu
               primer vuelo.
            </p>
         </div>

         <div className="contact-container">
            {/* Formulario */}
            <div className="contact-form-container">
               <form onSubmit={handleSubmit} className="contact-form-academy">
                  <div className="form-group">
                     <label>PILOTO / NOMBRE</label>
                     <input
                        type="text"
                        name="name"
                        placeholder="Tu nombre aquí"
                        value={formData.name}
                        onChange={handleChange}
                        className={errors.name ? "error-input" : ""}
                     />
                     {errors.name &&
                        <span className="error-message">{errors.name}</span>
                     }
                  </div>

                  <div className="form-row">
                     <div className="form-group">
                        <label>CORREO</label>
                        <input
                           type="email"
                           name="email"
                           placeholder="tu@email.com"
                           value={formData.email}
                           onChange={handleChange}
                           className={errors.email ? "error-input" : ""}
                        />
                        {errors.email &&
                           <span className="error-message">{errors.email}</span>
                        }
                     </div>
                     <div className="form-group">
                        <label>WHATSAPP (OPCIONAL)</label>
                        <input
                           type="text"
                           name="phone"
                           placeholder="+34 000 000 000"
                           value={formData.phone}
                           onChange={handleChange}
                           className={errors.phone ? "error-input" : ""}
                        />
                        {errors.phone && (
                           <span className="error-message">{errors.phone}</span>
                        )}
                     </div>
                  </div>

                  <div className="form-group">
                     <label className="selector-form">
                        <span>OBJETIVO</span>
                        <select
                           name="objective"
                           value={formData.objective}
                           onChange={handleChange}
                           className={errors.objective ? "error-input" : ""}
                        >
                           <option value="">Selecciona tu objetivo</option>
                           <option value="Asesoría de Compra">
                              Asesoría de Compra
                           </option>
                           <option value="Taller de Configuración">
                              Taller de Configuración
                           </option>
                           <option value="Clases de Vuelo">
                              Clases de Vuelo
                           </option>
                        </select>
                     </label>
                     {errors.objective && (
                        <span className="error-message">
                           {errors.objective}
                        </span>
                     )}
                  </div>

                  <div className="form-group">
                     <label>DETALLES DE LA CONSULTA</label>
                     <textarea
                        name="message"
                        placeholder="Cuéntame tus dudas sobre FPV o configuración..."
                        value={formData.message}
                        onChange={handleChange}
                        rows="5"
                        className={errors.message ? "error-input" : ""}
                     ></textarea>
                     {errors.message && (
                        <span className="error-message">{errors.message}</span>
                     )}
                  </div>

                  {/* He leido y aceptado los términos y condiciones y politica de privacidad */}
                  <div className="form-group">
                     <label className="checkbox-label">
                        <input
                           type="checkbox"
                           name="terms"
                           checked={formData.terms}
                           onChange={handleChange}
                           className={errors.terms ? "error-input" : ""}
                        />
                        <span>
                           He leído y aceptado los{" "}
                           <a
                              href="/condiciones"
                              target="_blank"
                              rel="noopener noreferrer"
                              title="Términos y condiciones"
                           >
                              términos y condiciones
                           </a>{" "}
                           y la{" "}
                           <a
                              href="/politica-privacidad"
                              target="_blank"
                              rel="noopener noreferrer"
                              title="Política de privacidad"
                           >
                              política de privacidad
                           </a>
                        </span>
                     </label>
                     {errors.terms && (
                        <span className="error-message">{errors.terms}</span>
                     )}
                  </div>

                  {loadRecaptcha && (
                     <div className="academy-captcha">
                        <ReCAPTCHA
                           sitekey="6LdDz3ErAAAAAAhHJsiE_QSd7FdcD0GEjhktCZkL"
                           onChange={(token) => setRecaptchaToken(token)}
                           ref={recaptchaRef}
                        />
                     </div>
                  )}

                  <button
                     type="submit"
                     className="btn-send"
                     disabled={isSubmitting}
                  >
                     {isSubmitting ? t("sending") : "ENVIAR MENSAJE"}
                  </button>
               </form>

               {/* Modal de estado del envío */}
               {submitMessage && (
                  <div className="submit-message-overlay">
                     <div
                        className={`submit-message ${
                           submitMessage.includes("éxito") ||
                           submitMessage.includes("successfully")
                              ? "success"
                              : "error"
                        }`}
                     >
                        <div className="message-icon">
                           {submitMessage.includes("éxito") ||
                           submitMessage.includes("successfully") ? (
                              <FaRegCheckCircle />
                           ) : (
                              <FaRegQuestionCircle />
                           )}
                        </div>
                        <p>{submitMessage}</p>
                        <button
                           className={`close-button  ${
                              submitMessage.includes("éxito") ||
                              submitMessage.includes("successfully")
                                 ? "success"
                                 : "error"
                           }`}
                           onClick={closeMessage}
                        >
                           <FaTimes />
                           <p>{t("close")}</p>
                        </button>
                     </div>
                  </div>
               )}
            </div>

            {/* Info lateral */}
            <div className="contact-info">
               <div className="info-item">
                  <div className="info-icon">
                     <FaWhatsapp />
                  </div>
                  <div className="contact-info-item-container">
                     <h3>WHATSAPP</h3>
                     <p>Atención directa y rápida</p>
                     <a
                        href="https://wa.me/615159344"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="WhatsApp"
                     >
                        ESCRÍBEME AHORA ↗
                     </a>
                  </div>
               </div>

               <div className="info-item">
                  <div className="info-icon">
                     <FaMailBulk />
                  </div>
                  <div className="contact-info-item-container">
                     <h3>CORREO</h3>
                     <p>falcon@joancompany.es</p>
                     <a href="mailto:falcon@joancompany.es" title="Enviar correo">
                        ENVIAR MAIL ↗
                     </a>
                  </div>
               </div>

               <div className="info-item">
                  <div className="info-icon">
                     <FaClock />
                  </div>
                  <div className="contact-info-item-container">
                     <h3>DISPONIBILIDAD</h3>
                     <p>Lunes a Viernes, 9h a 19h</p>
                  </div>
               </div>

               <div className="info-item">
                  <div className="info-icon">
                     <FaMapMarker />
                  </div>
                  <div className="contact-info-item-container">
                     <h3>UBICACIÓN</h3>
                     <p>Mallorca, Islas Baleares</p>
                  </div>
               </div>
            </div>
         </div>
      </section>
   );
};

export default Contact;
